import HomeIcon from '@mui/icons-material/Home';
import React from "react";
import { Drawer, List, ListItemButton, ListItemIcon, ListItemText, Toolbar } from "@mui/material";
import DashboardIcon from '@mui/icons-material/SpaceDashboard';
import LinkIcon from '@mui/icons-material/Link';
import PeopleIcon from '@mui/icons-material/People';
import BarChartIcon from '@mui/icons-material/BarChart';
import ListAltIcon from '@mui/icons-material/ListAlt';
import NotificationsIcon from '@mui/icons-material/Notifications'; // Thêm import icon Notifications
import { NavLink } from "react-router-dom";

// Thêm menu Notifications vào mảng menu
const menu = [
{ text: "Trang chủ", icon: <HomeIcon />, path: "/" }, // <- Thêm dòng này
  { text: "Dashboard", icon: <DashboardIcon />, path: "/teolucpro" },
 { text: "Quản lý link", icon: <LinkIcon />, path: "/teolucpro/links" },
  { text: "Quản lý user", icon: <PeopleIcon />, path: "/users" },
  { text: "Thống kê", icon: <BarChartIcon />, path: "/stats" },
  { text: "Lịch sử log", icon: <ListAltIcon />, path: "/logs" },
  { text: "Thông báo", icon: <NotificationsIcon />, path: "/notifications" }, // <- Thêm dòng này
];

export default function Sidebar() {
  return (
    <Drawer
      variant="permanent"
      sx={{
        width: 230, flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: 230, boxSizing: "border-box",
          bgcolor: "#0e1e40", color: "#fff", borderRight: "0px"
        }
      }}
    >
      <Toolbar sx={{ height: 68, fontWeight: 900, fontSize: 22, letterSpacing: 2, color: "#facc15", justifyContent: "center" }}>
        Admin
      </Toolbar>
      <List>
        {menu.map((m) => (
          <NavLink
            to={m.path}
            key={m.text}
            style={({ isActive }) => ({
              textDecoration: "none",
              color: isActive ? "#facc15" : "#fff"
            })}
          >
            <ListItemButton sx={{ py: 2, borderRadius: 3, my: 1, mx: 2 }}>
              <ListItemIcon sx={{ color: "#06b6d4" }}>{m.icon}</ListItemIcon>
              <ListItemText primary={m.text} />
            </ListItemButton>
          </NavLink>
        ))}
      </List>
    </Drawer>
  );
}
